import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row-center w-full" }
const _hoisted_2 = { class: "w-full align-c" }

import { useI18n } from 'vue-i18n';
import Paginator from 'primevue/paginator';
import { Pageable } from '@/apiGenerate/medserver';


export default /*@__PURE__*/_defineComponent({
  __name: 'esPaginator',
  props: {
    currentRef: {},
    pageable: {},
    total: {},
    loading: { type: Boolean }
  },
  emits: ['prevPage', 'nextPage'],
  setup(__props: any, { emit: __emit }) {



const { t } = useI18n();

const emits = __emit;

const prevPage = () => {
    emits('prevPage');
}

const nextPage = () => {
    emits('nextPage');
}

return (_ctx: any,_cache: any) => {
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_openBlock(), _createBlock(_unref(Paginator), {
    first: _ctx.pageable.start,
    rows: _ctx.pageable.limit,
    totalRecords: _ctx.total,
    ref: _ctx.currentRef
  }, {
    container: _withCtx(({ first, last, page, pageCount, prevPageCallback, nextPageCallback, totalRecords }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_es_button_icon, {
          icon: "chevron-left",
          folder: "navigationIcons",
          buttonStyles: "flex-square-24",
          onClick: ($event: any) => {prevPageCallback($event); prevPage();},
          styles: 'h-14 w-14',
          disabled: page === 0 || _ctx.loading
        }, null, 8, ["onClick", "disabled"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('common.pageable.showing', { first: first, last: last, total: totalRecords })), 1)
        ]),
        _createVNode(_component_es_button_icon, {
          icon: "chevron-right",
          folder: "navigationIcons",
          buttonStyles: "flex-square-24",
          onClick: ($event: any) => {nextPageCallback($event); nextPage();},
          styles: 'h-14 w-14',
          disabled: page === pageCount - 1 || _ctx.loading
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["first", "rows", "totalRecords"]))
}
}

})